import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "./ParticlesAuth";

//redux
import { useDispatch, useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

// actions
import { loginUser, resetLoginFlag, socialLogin } from "../../slices/thunks";

import { createSelector } from "reselect";
import AuthSlider from "modules/Authentication/authSlider";
//import images
import logoSm from "../../assets/images/logo-sm.png";
import { showSuccessToast, showErrorToast } from "../../helpers/toast_helper";
import { reset_login_flag } from "slices/auth/login/reducer";

const Login = (props: any) => {
  const dispatch: any = useDispatch();


  const selectLayoutState = (state: any) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Login.user,
    username: state.Login.username,
    // user: state.Login.user,
    error: state.Login.error,
    errorMsg: state.Login.errorMsg,
    isLoginError: state.Login.isLoginError,
    loginSuccessMsg: state.Login.loginSuccessMsg
  }));
  // Inside your component
  const { user, username, error, isLoginError, errorMsg, loginSuccessMsg } = useSelector(loginpageData);

  const [userLogin, setUserLogin] = useState<any>([]);
  const [passwordShow, setPasswordShow] = useState<boolean>(false);

  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    if (user && user) {
      const updatedUserData = username;
      const updatedUserPassword = user?.confirm_password;
      setUserLogin({
        email: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  useEffect(() => {
    if (loginSuccessMsg) {
      showSuccessToast(loginSuccessMsg, "login-success");
      dispatch(reset_login_flag());
    }

    if (errorMsg) {
      showErrorToast(errorMsg, "login-error");
      dispatch(reset_login_flag());
    }
  }, [loginSuccessMsg, errorMsg, dispatch]);



  const validation: any = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: userLogin?.username,
      password: userLogin?.password,
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .trim()
        .required("Please enter Username")
        .test("is-valid", "Enter a valid Username", (value) => {
          if (!value) return false;
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const phoneRegex = /^[0-9]{10}$/;
          const usernameRegex = /^[a-zA-Z0-9_]{3,20}$/;
          return (
            emailRegex.test(value) ||
            phoneRegex.test(value) ||
            usernameRegex.test(value)
          );
        }),
      password: Yup.string().trim().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
      setLoader(true);
    },
  });

  const signIn = (type: any) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //for facebook and google authentication
  const socialResponse = (type: any) => {
    signIn(type);
  };


  useEffect(() => {
    if (isLoginError) {
      // setTimeout(() => {
      dispatch(resetLoginFlag());
      setLoader(false);
      // }, 3000);
    }
  }, [dispatch, isLoginError]);

  useEffect(() => {
    setUserLogin({ email: "", password: "" });
  }, []);


  document.title = "AMANAT";
  return (
    <React.Fragment>
      <div className="auth-page-wrapper auth-bg-cover py-3 d-flex flex-column justify-content-center align-items-center">
        <div className="bg-overlay"></div>
        <div className="auth-page-content overflow-hidden pt-lg-3 flex-grow-1 d-flex align-items-center">
          <Container>
            <Row>
              <Col lg={12}>
                <Card className="overflow-hidden card-bg-fill galaxy-border-none auth-login-card">
                  <Row className="g-0 flex-column flex-lg-row">
                    <AuthSlider />

                    <Col xs={12} lg={6} className="order-2 auth-login-form-col">
                      <div className="p-lg-5 p-4 auth-login-form-inner">
                        <div className="mb-4">
                          <img
                            src={logoSm}
                            alt="App Logo"
                            height="58"
                          />
                        </div>
                        <div>
                          <h5 className="text-success">Welcome!</h5>
                          <p className="text-muted">
                            Login to continue.
                          </p>
                        </div>
                        {error && error ? (
                          <Alert color="danger"> {error} </Alert>
                        ) : null}
                        <div className="p-2 mt-4">
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            }}
                            action="#"
                          >
                            <div className="mb-3">
                              <Label htmlFor="email" className="form-label">
                                Username
                              </Label>
                              <Input
                                name="username"
                                className="form-control"
                                placeholder="Enter Username"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                invalid={validation.touched.username && !!validation.errors.username}
                              />
                              {validation.touched.username && validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.username}
                                </FormFeedback>
                              ) : null}

                            </div>

                            <div className="mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <Label
                                className="form-label mb-0"
                                htmlFor="password-input"
                              >
                                Password
                              </Label>
                                <Link
                                  to="/forgot-password"
                                  className="text-secondary small"
                                >
                                  Forgot password?
                                </Link>
                              </div>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Input
                                  name="password"
                                  value={validation.values.password || ""}
                                  type={passwordShow ? "text" : "password"}
                                  className="form-control"
                                  placeholder="Enter Password"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.password && validation.errors.password ? true : false
                                  }
                                />

                                <button
                                  className="btn btn-link position-absolute end-0 top-0 bottom-0 d-flex align-items-center justify-content-center text-decoration-none text-muted"
                                  type="button"
                                  id="password-addon"
                                  onClick={() => setPasswordShow(!passwordShow)}
                                >
                                  {passwordShow ? (
                                    <i className="ri-eye-off-fill"></i>
                                  ) : (
                                    <i className="ri-eye-fill"></i>
                                  )}
                                </button>

                                {validation.touched.password && validation.errors.password && (
                                  <FormFeedback type="invalid">
                                    {validation.errors.password}
                                  </FormFeedback>
                                )}
                              </div>

                            </div>



                            <div className="mt-4">
                              <Button
                                color="primary"
                                disabled={loader && true}
                                className="btn btn-primary w-100"
                                type="submit"
                              >
                                {loader && (
                                  <Spinner size="sm" className="me-2">
                                    {" "}
                                    Loading...{" "}
                                  </Spinner>
                                )}
                                Login
                              </Button>
                            </div>
                          </Form>
                        </div>
                        {/* <div className="mt-5 text-center">
                          <p className="mb-0">
                            Are you a new user ?{" "}
                            <Link
                              to="/register"
                              className="fw-semibold text-secondary text-decoration-underline"
                            >
                              {" "}
                              Create your account
                            </Link>{" "}
                          </p>
                        </div> */}
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0 text-muted">{new Date().getFullYear()} &copy; AMANAT.</p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
